'use strict';

var _ = require('lodash');
var Params = function Params(axisDirection) {
  return function (containerWidth, containerHeight) {
    var padding = axisDirection === 'right-to-left' ? _.assign({
      top: 30,
      bottom: 55
    }, {
      left: 30,
      right: 150
    }) : _.assign({
      top: 30,
      bottom: 55
    }, {
      left: 150,
      right: 30
    });
    var width = containerWidth - (padding.left + padding.right);
    var height = containerHeight - (padding.top + padding.bottom);
    return {
      width: width,
      height: height,
      containerWidth: containerWidth,
      containerHeight: containerHeight,
      padding: padding,
      xNumberOfTicks: 13,
      yNumberOfTicks: 8,
      yAxisShift: 5,
      xAxisLabelShift: 45,
      yAxisLabelShift: 70
    };
  };
};
module.exports = Params;